import { render } from "./serviceOfGods.vue?vue&type=template&id=32eee23c&scoped=true"
import script from "./serviceOfGods.vue?vue&type=script&lang=js"
export * from "./serviceOfGods.vue?vue&type=script&lang=js"

import "./serviceOfGods.vue?vue&type=style&index=0&id=32eee23c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32eee23c"]])

export default __exports__